import React from 'react';
import styled from 'styled-components';

import { VerticalMenuClickableItem } from '#/components/basic/Button/verticalMenu';
import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import MetaTags from '#/components/layout/header/MetaTags';
import VaultStatsPanel from '#/components/vaults/components/VaultStatsPanel';
import { useOwnVaultQuery } from '#/components/vaults/shared/utils';
import { fullLogoutAndDispatch } from '#/reduxState/currentUser/currentUserUtils';
import { staticDispatch, useSelector } from '#/reduxState/store';
import { scrollbarStyle } from '#/styleShared';

import WalletHeader from './header/WalletHeader';
import WalletDashboardMenu from './WalletDashboardMenu';
import WalletMenuStatsMobile from './WalletMenuStatsMobile';

const Wrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const ScrollableContent = styled.div`
  .isMobileStyle & {
    overflow-y: auto;
    ${scrollbarStyle}
  }
`;

const MenuWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 8px;
`;

function WalletDashboardMenuPageMobile() {
  const isCatchAllUser = useSelector(state => state.currentUser.isCatchAllUser);
  const loggedIn = useSelector(state => state.currentUser.loggedIn);
  const delegatedWallet = useSelector(
    state => state.delegatedKey.authorization
  );
  const ownVault = useOwnVaultQuery();
  const loggedInAsRealUser = loggedIn && !isCatchAllUser;
  const wallet = useSelector(state => state.wallet);
  const { walletAddress } = wallet;
  const disconnectWalletTitle = loggedInAsRealUser ? 'Sign Out' : 'Disconnect';
  return (
    <Wrap>
      <MetaTags title="Wallet" />

      <WalletHeader title="Wallet" showBalanceActions noBack />

      <ScrollableContent>
        <WalletMenuStatsMobile />

        <MenuWrap>
          <WalletDashboardMenu />
          <div style={{ padding: 4 }} />
          {(loggedInAsRealUser || walletAddress) && (
            <VerticalMenuClickableItem
              onClick={() =>
                fullLogoutAndDispatch(wallet, delegatedWallet, staticDispatch)
              }
              icon={<MaterialSymbol icon="close" fontSize="inherit" />}
            >
              {disconnectWalletTitle}
            </VerticalMenuClickableItem>
          )}
          {ownVault && (
            <div style={{ padding: '0 8px 8px' }}>
              <VaultStatsPanel managerWallet={ownVault.manager} />
            </div>
          )}
        </MenuWrap>
      </ScrollableContent>
    </Wrap>
  );
}

export default WalletDashboardMenuPageMobile;
